import { useRequestOauthAuthorize } from "@tandemdiabetes/sugarmate-api-react-client"
import { useMemo } from "react"
import { useOauthAuthorizeContext } from "src/contexts"
import { noticeError } from "src/utils"

export function useOauthAuthorize() {
  const {
    client_id,
    code_challenge,
    code_challenge_method,
    redirect_uri,
    response_type,
    scope,
    state,
  } = useOauthAuthorizeContext()

  const requestOauthAuthorize = useRequestOauthAuthorize()

  return useMemo(
    () => !requestOauthAuthorize
      ? undefined
      : async (accessToken: string): Promise<void> => {
        try {
          const response = await requestOauthAuthorize(
            accessToken,
            {
              client_id,
              code_challenge,
              code_challenge_method,
              redirect_uri,
              response_type,
              scope,
              state,
            },
          )

          if (response.data.status === "redirect") {
            location.replace(response.data.redirect_uri)
          } else {
            throw new Error("oauth authorization failed")
          }
        } catch (e) {
          noticeError(
            e,
            "OauthAuthorize",
          )

          throw e
        }
      },
    [
      client_id,
      code_challenge,
      code_challenge_method,
      redirect_uri,
      response_type,
      scope,
      state,
      requestOauthAuthorize,
    ],
  )
}
